import React from 'react'
import { FirstFloorStyled, LiveBets, ShowStats } from './FirstFloorStyled'

export default function FirstFloor({ betsAmount, show, handleToggle }: any) {
    return (
        <FirstFloorStyled>
            <LiveBets>LIVE BETS: <span>{betsAmount}</span></LiveBets>
            <ShowStats show={show} onClick={handleToggle}>{show ? 'HIDE STATS' : 'SHOW STATS'}</ShowStats>
        </FirstFloorStyled>

    )
}
